import React, { Component } from "react";
import { PageHeader } from "react-bootstrap";
import { Panel,
          Row,
          Col,
          Button,
          FormGroup,
          Tabs,
          Tab,
          FormControl,
          ControlLabel,
          Table,
          Checkbox,
          Glyphicon,
          Modal,
          ButtonGroup,
          DropdownButton,
          MenuItem,
          Tooltip,
          OverlayTrigger,
          ListGroup,
          ListGroupItem,
          Image,
          Radio} from "react-bootstrap";
import Truncate from 'react-truncate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DatePicker from 'react-16-bootstrap-date-picker';//has min/maxDate but no time
import Datetime from 'react-datetime';//has time but no min/maxDate
import {ToastContainer, ToastStore} from 'react-toasts';
//Props:
//choice
//postOrderIndex
//onChangePostOrder
//type
//newPostOrder
//choiceIndex
//isNew
class PostOrderOption extends Component {

  render() {
    const { choice, postOrderIndex, onChangePostOrder, type, newPostOrder, choiceIndex} = this.props;

      if(type === "checkbox") {
        return <Col md={4} key={choiceIndex} style={{ marginLeft: 0}}>
                    <Row style={{}}>
                      <Col md={1}>
                        <Checkbox inline disabled
                                  checked={choice.value ? choice.value : false}
                                  onChange={()=>{
                                    console.log("clicked ", choice.name);
                                  }}>
                          </Checkbox>
                      </Col>
                      <Col md={9} style={{}}>
                          <input type="text" style={{width: "100%", marginTop: 5}}
                            value={choice.name ? choice.name : "No Name"}
                            disabled={postOrderIndex != null}
                            onChange={(e)=>{
                              e.stopPropagation();

                              choice["name"] = e.target.value;
                              this.props.onChangeChoice(choice, choiceIndex);

                          }}/>
                      </Col>
                      <Glyphicon glyph="trash" disabled={postOrderIndex == null} className="pull-left col"
                              style={{cursor: "pointer", marginTop: 10, textAlign: "left"}}
                              onClick={()=>{
                                ToastStore.warning("Delete under construction!");
                              }}/>

                    </Row>
                </Col>
      } else if (type === "radio") {
        return <Col md={4} key={choiceIndex} style={{ marginLeft: 0}}>
                    <Row style={{}}>
                      <Col md={1}>
                        <Radio name={"groupOptions_"+postOrderIndex}  disabled
                          value={choice.name}
                          onChange={(e)=>{console.log("clicked "+ e.target.value);}}></Radio>
                      </Col>
                      <Col md={9} style={{}}>
                          <input type="text" style={{width: "100%", marginTop: 5}}
                            disabled={postOrderIndex != null}
                            value={choice.name ? choice.name : "No Name"}
                            onChange={(e)=>{
                              e.stopPropagation();
                              choice["name"] = e.target.value;
                              this.props.onChangeChoice(choice, choiceIndex);
                          }}/>
                      </Col>
                      <Glyphicon glyph="trash" className="pull-left col"
                              style={{cursor: "pointer", marginTop: 10, textAlign: "left"}}
                              onClick={()=>{
                                ToastStore.warning("Delete under construction!");
                              }}/>

                    </Row>
                </Col>
      } else {
        return <Col md={4} key={choiceIndex} style={{ marginLeft: 0}}>Unknown Choice Type</Col>
      }

  }

}

export default PostOrderOption
